<label class="col-sm-2 col-form-label">增加Tag類型</label>            
<select class="form-control" style="width: 160px;display: inline-block;margin-right: 50px;margin-left: 30px;" [(ngModel)]="tool_obj.tag" (ngModelChange)="showdeType(tool_obj.tag)">
    <option default disabled value="-2">請選擇Tag類型</option>
    <option *ngFor="let item of tag_list_type" [ngValue]="item.id">{{item.name}}</option>
</select>
<mat-form-field  *ngIf="tool_obj.tag > -1" style="width: 600px;">
    <mat-label>選擇呈現類別</mat-label>
    <mat-select [(ngModel)]="tool_obj.groupTag" multiple (ngModelChange)="showType(tool_obj.tag)" >
        <mat-option *ngFor="let item of groupTaglist[tool_obj.tag]" [value]="item.name">{{ item.name }}</mat-option>
    </mat-select>
</mat-form-field>
<div  *ngFor="let itex of groupTagArr; let ix = index">
    <div *ngIf="itex != null">
        <button  *ngFor="let item of itex; let i = index"  style="margin: 10px;" class="btn btn-primary"  (click)="clearbtn(item,ix,i)" >{{item}}</button>
    </div>
</div>